import { TextLiteralControlProps } from "types";
import "./text-literal-control.scss";

const TextLiteralControl = (props: TextLiteralControlProps) => {
	return (
		<div className="form-group row mb-2">
			<label htmlFor={props.name} className="col-sm-2 col-form-label text-end form-control-title">{props.label}:</label>
			<div className="col-sm-10">
				<input
					type="text"
					defaultValue={props.defaultValue}
					className="form-control-plaintext"
					placeholder={props.placeholder ?? props.label}
					tabIndex={props.tabIndex}
					readOnly
					{...props.formMethods?.register(props.name)}
				/>
			</div>
		</div>
	);
};

export default TextLiteralControl;